// extracted by mini-css-extract-plugin
export default {"paymentMethods":"PaymentMethods_paymentMethods__4y8TE","paymentMethodsWrapper":"PaymentMethods_paymentMethodsWrapper__Qql9Y"};